import React from 'react'

interface PageBannerProps {
  title: string
  description: string
  backgroundImage?: string
  avatarImage?: string
  avatarAlt?: string
}

export const PageBanner = ({ title, description, backgroundImage, avatarImage, avatarAlt }: PageBannerProps) => {
  if (!backgroundImage && !avatarImage) {
    return null
  }

  const defaultBackgroundImage = '/assets/images/banners/default-banner.jpg'
  const finalBackgroundImage = backgroundImage || defaultBackgroundImage

  return (
    <section className='
      tw-relative tw-w-full
      tw-min-h-[50vh] md:tw-min-h-[60vh]
      tw-overflow-hidden
      tw-flex tw-items-center tw-justify-center
      tw-py-12 md:tw-py-20 lg:tw-py-24'
    >
      {finalBackgroundImage && (
        <img
          src={finalBackgroundImage}
          alt={title || 'Tło sekcji hero'}
          className='tw-absolute tw-inset-0 tw-w-full tw-h-full tw-object-cover'
        />
      )}
      {finalBackgroundImage && <div className='tw-absolute tw-inset-0 tw-bg-black/50' />}

      <div className='tw-relative tw-z-10 tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8 tw-w-full'>
        <div className='tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-text-center md:tw-text-left'>

          {avatarImage && (
            <div className='
              tw-w-32 tw-h-32
              md:tw-w-40 md:tw-h-40
              lg:tw-w-48 lg:tw-h-48
              tw-rounded-full
              tw-overflow-hidden
              tw-border-2 tw-border-white
              tw-shadow-lg
              tw-mb-6 md:tw-mb-0 md:tw-mr-10 lg:tw-mr-12
              tw-flex-shrink-0'
            >
              <img
                src={avatarImage}
                alt={avatarAlt || title}
                className='tw-w-full tw-h-full tw-object-cover'
              />
            </div>
          )}

          <div className='tw-flex tw-flex-col'>
            <h1 className='tw-text-white tw-text-3xl sm:tw-text-4xl lg:tw-text-5xl xl:tw-text-6xl tw-font-bold tw-mb-3 md:tw-mb-4'>
              {title}
            </h1>
            <p className='tw-text-neutral-100 tw-text-base sm:tw-text-lg lg:tw-text-xl tw-max-w-xl md:tw-max-w-2xl lg:tw-max-w-3xl tw-leading-relaxed'>
              {description}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
